import DeleteIcon from '@material-design-icons/svg/filled/delete.svg?react';
import type { DappDetail } from '../../stores/dappsPageStore';
import { getDappDeletionConstraintMessage } from '../../utils/dappDeletion';

interface DeleteDappActionButtonProps {
  dapp: DappDetail;
  onClick: (dapp: DappDetail) => void;
  iconClassName?: string;
}

export function DeleteDappActionButton({
  dapp,
  onClick,
  iconClassName = 'w-4 h-4',
}: DeleteDappActionButtonProps) {
  const deletionBlockedMessage = getDappDeletionConstraintMessage(
    dapp.releaseCount,
  );

  return (
    <button
      type="button"
      onClick={(event) => {
        event.stopPropagation();

        if (!deletionBlockedMessage) {
          onClick(dapp);
        }
      }}
      disabled={Boolean(deletionBlockedMessage)}
      className="text-red-400 transition-colors hover:text-red-300 disabled:text-neutral-500 disabled:cursor-not-allowed disabled:hover:text-neutral-500"
      title={deletionBlockedMessage ?? 'Delete dapp'}
      aria-label={
        deletionBlockedMessage
          ? `Cannot delete ${dapp.dappName}`
          : `Delete ${dapp.dappName}`
      }
    >
      <DeleteIcon className={`fill-current ${iconClassName}`} />
    </button>
  );
}
